<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 短信群发 / 获取导出码</span>
      </div>

      <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">

        <table width="100%">
          <tr>
            <td class="leftTd">
              导出码
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="code" class="boxText"/>
            </td>
          </tr>
        </table>
        <div style="padding-top: 15px; padding-bottom: 25px; padding-left: 150px">
          <input @click="exportPhone" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="导出手机号" />
          <input @click="addAdmin" type="button" style="cursor: pointer; margin-left: 10px; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="获取导出码" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, FILE_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPost, axiosPostJson} from "@/main";
import axios from "axios";

export default {
  name: "CreateEmailAddressId",
  data(){
    return{
      name:"",
      rate:"",
      type:"0",
      note:"",
      code:""
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
  },
  methods: {
    async exportPhone() {
      console.log("开始导出")
      if(this.code==""){
        toask("请输入导出码",6)
        return
      }
      let that=this
      loading("请求中")
      let param="name="+this.name+"&rate="+this.rate+"&type="+this.type+"&note="+this.note
      axiosPost(DO_NET_URL+"other/ExportPhone?code="+this.code,"",function (res){
        console.log("这里是结果")
        console.log(res)
        closeLoading()
        if(res.code==200){
          const link = document.createElement('a');
          link.href = FILE_URL+"ExportFiles/"+res.data;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }else{
          toask(res.data,6)
        }

      })

    },
    addAdmin(){
      let that=this
      loading("请求中")
      let param="name="+this.name+"&rate="+this.rate+"&type="+this.type+"&note="+this.note
      axiosPost(DO_NET_URL+"other/CreateEmailAddressBookId","",function (res){
        closeLoading()
        alert(res.data)
      })
    },
    goback(){
      this.$emit("send",'awardList')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  /*line-height: 40px;*/
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>